type EnvConfig = {
  appBaseUrl: string;
  acntUrl: string;
  ssoUrl: string;
  logoutUrl: string;
  adobeUrl: string;
  cname: string;
  acntUatUrl?: string;
  acntStageUrl?: string;
  notFound?: string;
  consumerId?: string;
  mfaasStaticServer: string;
  mfaasConfigService: string;
  mfaasEnvironment: string;
};

export const envConfig = {
  local: {
    appBaseUrl: 'http://localhost:8080/acnt',
    acntUrl: 'http://localhost:3000',
    ssoUrl:
      // eslint-disable-next-line max-len
      'https://pfeddev.wal-mart.com/as/authorization.oauth2?client_id=acnt-grants&response_type=code&redirect_uri=http://localhost:3000/acnt-authorize&scope=openid profile full',
    logoutUrl: 'https://pfeddev.wal-mart.com/ext/fedlogout',
    adobeUrl: 'https://assets.adobedtm.com/54ac91b83be6/bdc1683f464a/launch-d3a5d7c9d7ca-development.min.js',
    cname: 'localhost',
    notFound: 'http://localhost:3000/not-found',
    consumerId: 'E6C7D488-BE4B-4BDB-9C29-E37560E751B8',

    //Chat config
    mfaasStaticServer: 'https://stg.mfaas-static.walmart.com',
    mfaasConfigService: 'https://stg.mfaas-static.walmart.com/mfe-config/v1',
    mfaasEnvironment: 'ebs-risktech-gr:development',
  },
  development: {
    appBaseUrl: 'https://ws.dev.acnt.walmart.com/acnt',
    acntUrl: 'https://dev.acnt.walmart.com',
    ssoUrl:
      // eslint-disable-next-line max-len
      'https://pfedcert.wal-mart.com/as/authorization.oauth2?client_id=acnt-grants&response_type=code&redirect_uri=https://dev.acnt.walmart.com/acnt-authorize&scope=openid profile full',
    logoutUrl: 'https://pfedcert.wal-mart.com/ext/fedlogout',
    adobeUrl: 'https://assets.adobedtm.com/54ac91b83be6/bdc1683f464a/launch-d3a5d7c9d7ca-development.min.js',
    acntStageUrl: 'https://stage.np.acnt.walmart.com',
    redirect_uri: 'https://stage.acnt.walmart.com/acnt-authorize',
    oAuthUrl: 'https://pfedcert.wal-mart.com/as/token.oauth2',
    cname: 'dev.acnt.walmart.com',
    notFound: 'https://dev.acnt.walmart.com/not-found',
    consumerId: 'E6C7D488-BE4B-4BDB-9C29-E37560E751B8',

    //Chat config
    mfaasStaticServer: 'https://stg.mfaas-static.walmart.com',
    mfaasConfigService: 'https://stg.mfaas-static.walmart.com/mfe-config/v1',
    mfaasEnvironment: 'ebs-risktech-gr:development',
  },
  stageInt: {
    appBaseUrl: 'https://developer.api.us.stg.walmart.com/api-proxy/service/acnt/ws/v1/acnt',
    acntUrl: 'https://stage.acnt.walmart.com',
    ssoUrl:
      // eslint-disable-next-line max-len
      'https://pfedcert.wal-mart.com/as/authorization.oauth2?client_id=acnt-grants&response_type=code&redirect_uri=https://stage.acnt.walmart.com/acnt-authorize&scope=openid profile full',
    logoutUrl: 'https://pfedcert.wal-mart.com/ext/fedlogout',
    adobeUrl: 'https://assets.adobedtm.com/54ac91b83be6/bdc1683f464a/launch-91bae92b006c-staging.min.js',
    cname: 'stage.acnt.walmart.com',
    redirect_uri: 'https://stage.acnt.walmart.com/acnt-authorize',
    oAuthUrl: 'https://pfedcert.wal-mart.com/as/token.oauth2',
    notFound: 'https://stage.acnt.walmart.com/not-found',
    consumerId: '13289AAC-A6A4-4448-9CBE-06723D264E82',

    //Chat config
    mfaasStaticServer: 'https://stg.mfaas-static.walmart.com',
    mfaasConfigService: 'https://stg.mfaas-static.walmart.com/mfe-config/v1',
    mfaasEnvironment: 'ebs-risktech-gr:stg',
  },
  stageExt: {
    appBaseUrl: 'https://developer.api.us.stg.walmart.com/api-proxy/service/acnt/ws/v1/acnt',
    acntUrl: 'https://stage.acnt.walmart.com',
    ssoUrl:
      // eslint-disable-next-line max-len
      'https://pfedcert.wal-mart.com/as/authorization.oauth2?client_id=acnt-grants&response_type=code&redirect_uri=https://stage.acnt.walmart.com/acnt-authorize&scope=openid profile full',
    logoutUrl: 'https://pfedcert.wal-mart.com/ext/fedlogout',
    adobeUrl: 'https://assets.adobedtm.com/54ac91b83be6/bdc1683f464a/launch-91bae92b006c-staging.min.js',
    cname: 'stage.acnt.walmart.com',
    redirect_uri: 'https://stage.acnt.walmart.com/acnt-authorize',
    oAuthUrl: 'https://pfedcert.wal-mart.com/as/token.oauth2',
    notFound: 'https://stage.acnt.walmart.com/not-found',
    consumerId: '13289AAC-A6A4-4448-9CBE-06723D264E82',

    //Chat config
    mfaasStaticServer: 'https://stg.mfaas-static.walmart.com',
    mfaasConfigService: 'https://stg.mfaas-static.walmart.com/mfe-config/v1',
    mfaasEnvironment: 'ebs-risktech-gr:stg',
  },
  uat: {
    appBaseUrl: 'https://ws.uat.np.acnt.walmart.com/acnt',
    acntUrl: 'https://uat.np.acnt.walmart.com',
    ssoUrl:
      // eslint-disable-next-line max-len
      'https://pfedcert.wal-mart.com/as/authorization.oauth2?client_id=acnt-grants&response_type=code&redirect_uri=https://uat.np.acnt.walmart.com/acnt-authorize&scope=openid profile full',
    logoutUrl: 'https://pfedcert.wal-mart.com/ext/fedlogout',
    adobeUrl: 'https://assets.adobedtm.com/54ac91b83be6/bdc1683f464a/launch-91bae92b006c-staging.min.js',
    cname: '.np.acnt.walmart.com',
    acntStageUrl: 'https://stage.np.acnt.walmart.com',
    acntUatUrl: 'https://uat.np.acnt.walmart.com',
    notFound: 'https://uat.np.acnt.walmart.com/not-found',
    consumerId: '13289AAC-A6A4-4448-9CBE-06723D264E82',

    //Chat config
    mfaasStaticServer: 'https://stg.mfaas-static.walmart.com',
    mfaasConfigService: 'https://stg.mfaas-static.walmart.com/mfe-config/v1',
    mfaasEnvironment: 'ebs-risktech-gr:stg',
  },
  production: {
    appBaseUrl: 'https://developer.api.us.walmart.com/api-proxy/service/acnt/ws/v1/acnt',
    acntUrl: 'https://acnt.walmart.com',
    ssoUrl:
      // eslint-disable-next-line max-len
      'https://pfedprod.wal-mart.com/as/authorization.oauth2?client_id=acnt-grants&response_type=code&redirect_uri=https://acnt.walmart.com/acnt-authorize&scope=openid profile full',
    logoutUrl: 'https://pfedprod.wal-mart.com/ext/fedlogout',
    adobeUrl: 'https://assets.adobedtm.com/54ac91b83be6/bdc1683f464a/launch-e64653d3a38f.min.js',
    cname: 'acnt.walmart.com',
    notFound: 'https://acnt.walmart.com/not-found',
    consumerId: '8EA23F39-D809-4FC3-9160-5032419364FD',

    //Chat config
    mfaasStaticServer: 'https://mfaas-static.walmart.com',
    mfaasConfigService: 'https://mfaas-static.walmart.com/mfe-config/v1',
    mfaasEnvironment: 'ebs-risktech-gr:prod',
  },
};

export const getEnvironment = (url: string) => {
  if (url.includes('acnt.gdms-ui.test') || url.includes('dev.acnt')) {
    return 'development';
  } else if (url.includes('acntuat') || url.includes('uat.np.acnt')) {
    return 'uat';
  } else if (url.includes('acnt.gdms.stage.internal') || url.includes('stage.np.acnt')) {
    return 'stageInt';
  } else if (url.includes('stage.acnt')) {
    return 'stageExt';
  } else if (url.includes('localhost')) {
    return 'local';
  } else if (
    url.includes('acnt.gdms.nextgen.internal') ||
    url.includes('acnt.walmart.com') ||
    url.includes('acnt-int.walmart.com')
  ) {
    return 'production';
  } else {
    return 'none';
  }
};

export const defaultConfig = {
  appBaseUrl: `${envConfig[getEnvironment(window.location.origin)].notFound}`,
  acntUrl: `${envConfig[getEnvironment(window.location.origin)].notFound}`,
  ssoUrl: `${envConfig[getEnvironment(window.location.origin)].notFound}`,
  logoutUrl: `${envConfig[getEnvironment(window.location.origin)].notFound}`,
  adobeUrl: `${envConfig[getEnvironment(window.location.origin)].notFound}`,
  cname: `${envConfig[getEnvironment(window.location.origin)].notFound}`,
  notFound: `${envConfig[getEnvironment(window.location.origin)].notFound}`,
  consumerId: `${envConfig[getEnvironment(window.location.origin)].notFound}`,
  mfaasStaticServer: 'https://mfaas-static.walmart.com',
  mfaasConfigService: 'https://mfaas-static.walmart.com/mfe-config/v1',
  mfaasEnvironment: 'ebs-risktech-gr:prod',
};

export const getAppConfigData = () => {
  let configData;
  const origin = window.location.origin;
  const env = getEnvironment(origin);
  switch (env) {
    case 'development':
      configData = envConfig.development;
      break;
    case 'uat':
      configData = envConfig.uat;
      break;
    case 'stageInt':
      configData = envConfig.stageInt;
      break;
    case 'stageExt':
      configData = envConfig.stageExt;
      break;
    case 'local':
      configData = envConfig.local;
      break;
    case 'production':
      configData = envConfig.production;
      break;
    default:
      configData = defaultConfig;
      break;
  }
  return configData;
};

export const appConfig: EnvConfig = getAppConfigData();

export default appConfig;
